import evaViewPopup from '!!raw-loader!./eva-view-popup.html'

export default { 'eva-view-popup': evaViewPopup }
